import React, { useState, useMemo } from "react";
import "@/App.css";
import { NewsCard } from "./components/NewsCard";
import { FilterBar } from "./components/FilterBar";
import { SearchBar } from "./components/SearchBar";
import { NewsModal } from "./components/NewsModal";
import { Menu, X } from "lucide-react";

// News Data
const articlesData = [
  {
    id: 1,
    title: "Global Leaders Agree on Historic Climate Accord at UN Summit",
    excerpt: "In a sweeping new agreement, over 100 nations have committed to aggressive carbon reduction targets by 2030, marking a turning point in global politics.",
    category: "World",
    date: "Feb 15, 2026",
    image_url: "https://images.pexels.com/photos/8850825/pexels-photo-8850825.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    featured: true
  },
  {
    id: 2,
    title: "Next-Gen Robotics: How AI is Reshaping Manufacturing",
    excerpt: "New autonomous systems are drastically reducing production times in modern factories across the globe.",
    category: "Technology",
    date: "Feb 14, 2026",
    image_url: "https://images.unsplash.com/photo-1773558057689-847e19466840?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwyfHx0ZWNobm9sb2d5JTIwYXJ0aWZpY2lhbCUyMGludGVsbGlnZW5jZSUyMHJvYm90aWNzfGVufDB8fHx8MTc3NTU2NDE3OXww&ixlib=rb-4.1.0&q=85",
    featured: true
  },
  {
    id: 3,
    title: "Markets Rally as Tech Stocks Hit Record Highs",
    excerpt: "Investors show renewed confidence as top technology firms report unprecedented quarterly earnings.",
    category: "Business",
    date: "Feb 14, 2026",
    image_url: "https://images.unsplash.com/photo-1766218329569-53c9270bb305?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHwxfHxlY29ub215JTIwYnVzaW5lc3MlMjBzdG9jayUyMG1hcmtldHxlbnwwfHx8fDE3NzU1NjQxOTN8MA&ixlib=rb-4.1.0&q=85",
    featured: true
  },
  {
    id: 4,
    title: "Desert Blooms: Unexpected Flora Following Heavy Rains",
    excerpt: "Climate anomalies have resulted in a rare, widespread blooming event across historically arid regions.",
    category: "Environment",
    date: "Feb 13, 2026",
    image_url: "https://images.unsplash.com/photo-1616443586071-cd1f0a65ef5e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwxfHxjbGltYXRlJTIwY2hhbmdlJTIwZW52aXJvbm1lbnQlMjBuYXR1cmV8ZW58MHx8fHwxNzc1NTY0MTc5fDA&ixlib=rb-4.1.0&q=85",
    featured: false
  },
  {
    id: 5,
    title: "New Exhibit Explores the Intersection of Classical Art and Digital Media",
    excerpt: "A prominent national museum unveils its controversial new gallery blending marble statues with augmented reality.",
    category: "Arts",
    date: "Feb 12, 2026",
    image_url: "https://images.unsplash.com/photo-1705996896056-41fb463106ec?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzV8MHwxfHNlYXJjaHwyfHxhcnRzJTIwY3VsdHVyZSUyMG11c2V1bXxlbnwwfHx8fDE3NzU1NjQxOTN8MA&ixlib=rb-4.1.0&q=85",
    featured: false
  },
  {
    id: 6,
    title: "The Rise of Autonomous Supply Chains",
    excerpt: "How shipping companies are utilizing AI to predict disruptions and reroute cargo without human intervention.",
    category: "Technology",
    date: "Feb 12, 2026",
    image_url: "https://images.unsplash.com/photo-1655393001768-d946c97d6fd1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwxfHx0ZWNobm9sb2d5JTIwYXJ0aWZpY2lhbCUyMGludGVsbGlnZW5jZSUyMHJvYm90aWNzfGVufDB8fHx8MTc3NTU2NDE3OXww&ixlib=rb-4.1.0&q=85",
    featured: false
  },
  {
    id: 7,
    title: "Global Summit Shifts Focus to Economic Equity",
    excerpt: "Delegates pivot from standard trade agreements to focus on wealth distribution and fair labor practices.",
    category: "World",
    date: "Feb 11, 2026",
    image_url: "https://images.pexels.com/photos/8850837/pexels-photo-8850837.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    featured: false
  },
  {
    id: 8,
    title: "Stadium Designs of the Future: Zero Emission Venues",
    excerpt: "A look inside the architectural marvels being built for the next decade's major sporting events.",
    category: "Sports",
    date: "Feb 10, 2026",
    image_url: "https://images.unsplash.com/photo-1764050359179-517599dab87b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwxfHxzcG9ydHMlMjBzdGFkaXVtJTIwYXRobGV0ZXxlbnwwfHx8fDE3NzU1NjQxOTN8MA&ixlib=rb-4.1.0&q=85",
    featured: false
  },
  {
    id: 9,
    title: "Local Fisheries Adapt to Changing Ocean Temperatures",
    excerpt: "Fishermen share their frontline experiences as shifting currents bring new species into local waters.",
    category: "Environment",
    date: "Feb 09, 2026",
    image_url: "https://images.unsplash.com/photo-1592867381986-b99599142ca6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHw0fHxjbGltYXRlJTIwY2hhbmdlJTIwZW52aXJvbm1lbnQlMjBuYXR1cmV8ZW58MHx8fHwxNzc1NTY0MTc5fDA&ixlib=rb-4.1.0&q=85",
    featured: false
  },
  {
    id: 10,
    title: "Wall Street Reacts to Unexpected Policy Rate Changes",
    excerpt: "Financial centers brace for volatility following today's surprise announcement from the central bank.",
    category: "Business",
    date: "Feb 08, 2026",
    image_url: "https://images.unsplash.com/photo-1773266110858-acb9b6c43b15?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHwyfHxlY29ub215JTIwYnVzaW5lc3MlMjBzdG9jayUyMG1hcmtldHxlbnwwfHx8fDE3NzU1NjQxOTN8MA&ixlib=rb-4.1.0&q=85",
    featured: false
  }
];

function App() {
  const [searchQuery, setSearchQuery] = useState("");
  const [activeCategory, setActiveCategory] = useState("All");
  const [selectedArticle, setSelectedArticle] = useState(null);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  // Filter articles based on search and category
  const filteredArticles = useMemo(() => {
    return articlesData.filter((article) => {
      const matchesCategory = activeCategory === "All" || article.category === activeCategory;
      const matchesSearch = article.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
                          article.excerpt.toLowerCase().includes(searchQuery.toLowerCase());
      return matchesCategory && matchesSearch;
    });
  }, [searchQuery, activeCategory]);

  // Get featured articles (first 3)
  const featuredArticles = filteredArticles.filter(a => a.featured).slice(0, 3);
  
  // Get remaining articles
  const remainingArticles = filteredArticles.filter(a => !featuredArticles.includes(a));

  return (
    <div className="min-h-screen bg-[#F9F9F8]" data-testid="app-container">
      {/* Navigation */}
      <nav className="nav-wrapper" data-testid="navigation">
        <div className="container-main">
          <div className="flex items-center justify-between h-16 md:h-20">
            {/* Logo */}
            <a 
              href="/" 
              className="font-heading font-black text-2xl md:text-3xl tracking-tighter"
              data-testid="logo"
            >
              Editorial<span className="text-[#E63946]">Pulse</span>
            </a>

            {/* Desktop Nav */}
            <div className="hidden md:flex items-center gap-8">
              <a href="#news" className="font-secondary text-sm font-medium hover:text-[#E63946] transition-colors">News</a>
              <a href="#categories" className="font-secondary text-sm font-medium hover:text-[#E63946] transition-colors">Categories</a>
              <a href="#about" className="font-secondary text-sm font-medium hover:text-[#E63946] transition-colors">About</a>
            </div>

            {/* Mobile Menu Button */}
            <button 
              className="md:hidden p-2"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              data-testid="mobile-menu-btn"
              aria-label="Toggle menu"
            >
              {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </div>

          {/* Mobile Menu */}
          {mobileMenuOpen && (
            <div className="md:hidden py-4 border-t border-gray-200 animate-slideUp" data-testid="mobile-menu">
              <a href="#news" className="block py-2 font-secondary text-sm font-medium">News</a>
              <a href="#categories" className="block py-2 font-secondary text-sm font-medium">Categories</a>
              <a href="#about" className="block py-2 font-secondary text-sm font-medium">About</a>
            </div>
          )}
        </div>
      </nav>

      {/* Main Content */}
      <main>
        {/* Header Section with Search */}
        <section className="container-main py-8 md:py-12" data-testid="header-section">
          <div className="max-w-3xl">
            <h1 className="font-heading font-black text-4xl md:text-5xl lg:text-6xl tracking-tighter leading-none mb-4">
              Today's Headlines
            </h1>
            <p className="font-body text-lg text-gray-600 mb-8">
              Stay informed with the latest news from around the world.
            </p>
            
            {/* Search Bar */}
            <SearchBar 
              searchQuery={searchQuery} 
              onSearchChange={setSearchQuery} 
            />
          </div>
        </section>

        {/* Filter Section */}
        <section className="container-main py-4" id="categories" data-testid="filter-section">
          <FilterBar 
            activeCategory={activeCategory} 
            onCategoryChange={setActiveCategory} 
          />
        </section>

        {/* Results Count */}
        <section className="container-main pb-4">
          <p className="text-sm text-gray-500 font-mono" data-testid="results-count">
            {filteredArticles.length} article{filteredArticles.length !== 1 ? 's' : ''} found
          </p>
        </section>

        {/* Hero/Featured Section */}
        {featuredArticles.length > 0 && searchQuery === "" && activeCategory === "All" && (
          <section className="container-main pb-8" id="news" data-testid="featured-section">
            <div className="hero-grid border border-[#E5E5E5]">
              {/* Main Featured Article */}
              {featuredArticles[0] && (
                <div className="hero-featured bg-white">
                  <NewsCard 
                    article={featuredArticles[0]} 
                    onClick={setSelectedArticle}
                    variant="featured"
                  />
                </div>
              )}
              
              {/* Secondary Featured Articles */}
              {featuredArticles.slice(1, 3).map((article) => (
                <div key={article.id} className="bg-white">
                  <NewsCard 
                    article={article} 
                    onClick={setSelectedArticle}
                  />
                </div>
              ))}
            </div>
          </section>
        )}

        {/* News Grid */}
        <section className="container-main pb-12" data-testid="news-grid-section">
          {filteredArticles.length === 0 ? (
            <div className="text-center py-16" data-testid="no-results">
              <p className="font-heading text-2xl text-gray-400 mb-2">No articles found</p>
              <p className="text-gray-500">Try adjusting your search or filter criteria.</p>
            </div>
          ) : (
            <div className="news-grid border border-[#E5E5E5]">
              {(searchQuery !== "" || activeCategory !== "All" ? filteredArticles : remainingArticles).map((article) => (
                <NewsCard 
                  key={article.id}
                  article={article} 
                  onClick={setSelectedArticle}
                />
              ))}
            </div>
          )}
        </section>

        {/* About Section */}
        <section className="bg-white border-t border-[#E5E5E5] py-12 md:py-16" id="about" data-testid="about-section">
          <div className="container-main">
            <div className="max-w-2xl">
              <h2 className="font-heading font-bold text-3xl md:text-4xl mb-4">About Editorial Pulse</h2>
              <p className="font-body text-gray-600 leading-relaxed mb-4">
                Editorial Pulse delivers authoritative news coverage from around the globe. 
                Our commitment to journalistic integrity ensures you receive accurate, 
                unbiased reporting on the stories that matter most.
              </p>
              <p className="font-body text-gray-600 leading-relaxed">
                From breaking world news to in-depth analysis of technology, business, 
                environment, arts, and sports, we keep you informed and engaged with 
                the issues shaping our world.
              </p>
            </div>
          </div>
        </section>
      </main>

      {/* Footer */}
      <footer className="footer-wrapper py-8 md:py-12" data-testid="footer">
        <div className="container-main">
          <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-6">
            <div>
              <p className="font-heading font-black text-xl text-white mb-2">
                Editorial<span className="text-[#E63946]">Pulse</span>
              </p>
              <p className="text-gray-400 text-sm">
                Your trusted source for global news.
              </p>
            </div>
            <div className="flex gap-6 text-sm text-gray-400">
              <a href="#" className="hover:text-white transition-colors">Privacy Policy</a>
              <a href="#" className="hover:text-white transition-colors">Terms of Service</a>
              <a href="#" className="hover:text-white transition-colors">Contact</a>
            </div>
          </div>
          <div className="mt-8 pt-8 border-t border-gray-800 text-center text-gray-500 text-sm">
            <p>&copy; 2026 Editorial Pulse. All rights reserved.</p>
          </div>
        </div>
      </footer>

      {/* Modal */}
      {selectedArticle && (
        <NewsModal 
          article={selectedArticle} 
          onClose={() => setSelectedArticle(null)} 
        />
      )}
    </div>
  );
}

export default App;
